"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var moment = require("moment");
var validators_1 = require("./../validators");
var DatePairComponent = (function () {
    // expand sections
    function DatePairComponent() {
        this.messages = {
            date1: {
                required: '',
                invalid: '',
                beforeToday: '',
                afterMax: '',
                beforeMin: '',
                beforeDeparture: ''
            },
            date2: {
                required: '',
                invalid: '',
                beforeToday: '',
                afterMax: '',
                beforeMin: '',
                beforeDeparture: ''
            }
        };
    }
    DatePairComponent.prototype.ngOnChanges = function (changes) {
        this.setMessages();
    };
    DatePairComponent.prototype.setMessages = function () {
        this.messages = {
            date1: {
                required: this.date1Label + ' is required.',
                invalid: this.date1Label + ' must be a valid date in mm/dd/yyyy format.',
                beforeToday: this.date1Label + ' must be a valid date in the future.',
                afterMax: this.date1Label + ' must be on or before ' + this.formatDateForDisplay(this.date1MaxDate) + '.',
                beforeMin: this.date1Label + ' must be on or after ' + this.formatDateForDisplay(this.date1MinDate) + '.',
                beforeDeparture: this.date1Label + ' must be on or after ' + this.date2Label
            },
            date2: {
                required: this.date2Label + ' is required.',
                invalid: this.date2Label + ' must be a valid date in mm/dd/yyyy format.',
                beforeToday: this.date2Label + ' must be a valid date in the future.',
                afterMax: this.date2Label + ' must be on or before ' + this.formatDateForDisplay(this.date2MaxDate) + '.',
                beforeMin: this.date2Label + ' must be on or after ' + this.formatDateForDisplay(this.date2MinDate) + '.',
                beforeDeparture: this.date2Label + ' must be on or after ' + this.date1Label
            }
        };
    };
    DatePairComponent.prototype.formatDateForDisplay = function (dateString) {
        return moment(dateString).format(validators_1.Constants.DATE_DISPLAY_FORMAT);
    };
    return DatePairComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", forms_1.FormGroup)
], DatePairComponent.prototype, "form", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DatePairComponent.prototype, "submitted", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DatePairComponent.prototype, "date1Label", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DatePairComponent.prototype, "date2Label", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DatePairComponent.prototype, "date1FormControlName", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DatePairComponent.prototype, "date2FormControlName", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DatePairComponent.prototype, "date1MaxDate", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DatePairComponent.prototype, "date1MinDate", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DatePairComponent.prototype, "date2MaxDate", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DatePairComponent.prototype, "date2MinDate", void 0);
DatePairComponent = __decorate([
    core_1.Component({
        selector: 'date-pair',
        template: "<div [formGroup]=\"form\">     <div class=\"form-group col-md-4\">         <label>{{date1Label}}</label>         <masked-datepicker placeholder=\"{{date1Label}}\" formControlName=\"{{date1FormControlName}}\"></masked-datepicker>         <validation-messages [control]=\"form.controls[date1FormControlName]\"                              [messages]=\"messages.date1\"                              [submitted]=\"submitted\">          </validation-messages>     </div>     <div class=\"form-group col-md-4\">         <label>{{date2Label}}</label>         <masked-datepicker placeholder=\"{{date2Label}}\" formControlName=\"{{date2FormControlName}}\"></masked-datepicker>         <validation-messages [control]=\"form.controls[date2FormControlName]\"                              [messages]=\"messages.date2\"                              [submitted]=\"submitted\"></validation-messages>     </div> </div>"
    }),
    __metadata("design:paramtypes", [])
], DatePairComponent);
exports.DatePairComponent = DatePairComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/date-pair/date-pair.component.js